module.exports = __webpack_public_path__ + "img/vinogradova.7625e7f9.jpg";